import { atom } from "recoil";

const systemPromptState = atom({
  key: "systemPromptState",
  default: {
    changed: true,
    role: "system",
    content: "You are Taotensor, a helpful assistant!"
  },
});

export default systemPromptState;